import right_arrow from 'assets/images/right_arrow.svg'
import cn from 'classnames'
import { Image } from 'components/Custom'
import { LabelValuePair } from 'components/Custom'
import { MoreInfo } from 'components/Custom/MoreInfo'
import { BodyText, TitleText } from 'components/Custom/Typographies'
import { Box } from 'components/Material/Box'
import { LIST_DOCUMENT_STATUS_SELECT } from 'enums/selects'
import useDocumentsManagementStore from 'store/useDocumentsManagementStore'
import useSidebarStore from 'store/useSidebar'
import { ListDocumentType } from 'types/documentos'
import formataData from 'utils/formataData'
import { maskCNPJCPF } from 'utils/formataValidaDocumentos'

type CardProps = {
  proposal: ListDocumentType
  isSelected: boolean
  onClick?: () => void
}

const CardDocuments = ({ proposal, isSelected, onClick }: CardProps) => {
  const { openSidebar } = useSidebarStore()
  const { setProduct, clearStage } = useDocumentsManagementStore((state) => state)

  const handleDetails = () => {
    clearStage()
    setProduct(proposal)
    openSidebar('documents-detail')
  }

  const handleSelectedProposal = () => {
    onClick && onClick()
    clearStage()
    setProduct(proposal)
  }

  const getStatusLabel = (value: string) => {
    const status = LIST_DOCUMENT_STATUS_SELECT.find((status) => status.value === value)
    return status ? status.label : ''
  }
  return (
    <Box
      onClick={handleSelectedProposal}
      className={cn('p-5 space-y-5 rounded-lg flex-1  max-w-[288px] min-w-[287px] border', {
        'bg-gray-15': isSelected,
        'bg-[#fffbfe] ': !isSelected
      })}
    >
      <Box className="flex justify-between space-x-5">
        <Box>
          <TitleText text={maskCNPJCPF(proposal.cd_inscricao_nacional)} typeStyle="large" />

          <BodyText text={getStatusLabel(proposal.st_status)} typeStyle="medium" />
        </Box>
        <Box className="w-12 h-12 p-2">
          <Image src={right_arrow} alt="right_arrow" className="w-6 h-6 text-blue-bb" />
        </Box>
      </Box>

      <Box>
        <LabelValuePair label="Nome" value={proposal.nm_pessoa} />
      </Box>
      <Box className="flex justify-between">
        <LabelValuePair
          label={proposal.id_documento_final > 0 ? 'Proposta Inicial' : 'Proposta'}
          value={proposal.id_documento}
        />

        {proposal.id_documento_final > 0 && (
          <LabelValuePair label="Proposta Final" value={proposal.id_documento_final} />
        )}
      </Box>
      <Box className="flex justify-between">
        <LabelValuePair label="Vencimento" value={formataData(proposal.dt_vencimento)} />
        <LabelValuePair label="Código comisionado" value={proposal.cd_comissionado} />
      </Box>
      <MoreInfo onClick={handleDetails} />
    </Box>
  )
}

export default CardDocuments
